/** What the version gate does next, given the current flag, build, and reload-attempt state. */
export type NextAction =
  | "waiting-for-flags"
  | "up-to-date"
  | "show-dialog"
  | "force-update-then-reload"
  | "unregister-then-reload";

/** State the version gate branches on; see `VersionCheckDialog` for how each value is derived. */
export type VersionGateState = {
  flagsLoaded: boolean;
  isStale: boolean;
  exhaustedReloads: boolean;
  isNewTarget: boolean;
};

/** Mirrors the branch order of `VersionCheckDialog`'s reload effect and the dialog's `open` condition. */
export function resolveNextAction(state: VersionGateState): NextAction {
  if (!state.flagsLoaded) return "waiting-for-flags";
  if (!state.isStale) return "up-to-date";
  if (state.exhaustedReloads) return "show-dialog";
  return state.isNewTarget ? "force-update-then-reload" : "unregister-then-reload";
}
